export interface IRawMaterialPick { batchId: number; quantity: number; }

export interface IManufacturingBatchInput {
  rawMaterialQuantity?: number;
  rawMaterialBatches?: IRawMaterialPick[];
  operationId?: string;
  addedQuantity?: number;
  addedRawMaterialQuantity?: number;
  expectedManufacturingVersion?: number;
}

export interface ICreateBatch extends IManufacturingBatchInput {
  productId: number;
  storeId: number;
  enteredQuantity: number;
  batchNumber?: string;
  expirationDate: string;
  purchaseDate: string;
  storableType: number;
  storableId: number;
  notes?: string;
  /** Cost of one *selling* unit (kg / piece / box), never of one gram, while
   *  `enteredQuantity` stays in base units. The currency is not sent: the
   *  server stamps it from the product's store pricing at creation and never
   *  revisits it. */
  purchasePrice: number;
}

export interface ITransferBatch {
  storableType: number;
  storableId: number;
  reason?: string;
}

export interface IUpdateBatch extends IManufacturingBatchInput {
  enteredQuantity?: number;
  batchNumber?: string;
  expirationDate?: string;
  purchaseDate?: string;
  notes?: string;
  /** Sent only to correct a mistyped cost. Omitting it leaves the stored price
   *  alone, and the stamped currency is untouchable either way. */
  purchasePrice?: number;
}

export enum BatchWriteOffReason {
  BALANCE_DISCREPANCY = 1,
  WASTE = 2,
  SHRINKAGE_EXPENSE = 3,
  WRITE_OFF = 4,
  EXPIRY = 5,
}

export interface IWriteOffBatch {
  quantity: number;
  reason: BatchWriteOffReason | number;
  notes?: string;
}
